import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  compact?: boolean;
}
export function CountdownTimer({
  compact = false
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 0,
    seconds: 0
  });
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
    const savedEndTime = localStorage.getItem('offerEndTime');
    let endTime: number;
    if (savedEndTime) {
      endTime = parseInt(savedEndTime, 10);
      if (endTime < Date.now()) {
        endTime = Date.now() + 2 * 60 * 60 * 1000;
        localStorage.setItem('offerEndTime', endTime.toString());
      }
    } else {
      endTime = Date.now() + 2 * 60 * 60 * 1000;
      localStorage.setItem('offerEndTime', endTime.toString());
    }
    const interval = setInterval(() => {
      const now = Date.now();
      const distance = endTime - now;
      if (distance < 0) {
        const newEndTime = Date.now() + 2 * 60 * 60 * 1000;
        localStorage.setItem('offerEndTime', newEndTime.toString());
        return;
      }
      setTimeLeft({
        hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
        minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(distance % (1000 * 60) / 1000)
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  if (!mounted) return null;
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  if (compact) {
    return <span className="font-mono font-black text-sm md:text-base text-white tracking-widest" data-id="element-63">
        {formatTime(timeLeft.hours)}:{formatTime(timeLeft.minutes)}:
        {formatTime(timeLeft.seconds)}
      </span>;
  }
  return <div className="flex items-center justify-center space-x-2 text-yellow-400 font-black text-2xl md:text-4xl tracking-wider drop-shadow-md" data-id="element-64">
      <div className="flex flex-col items-center" data-id="element-65">
        <span className="bg-black/20 px-3 py-1 rounded-md" data-id="element-66">
          {formatTime(timeLeft.hours)}
        </span>
        <span className="text-[10px] uppercase text-yellow-200 mt-1" data-id="element-67">
          Horas
        </span>
      </div>
      <span className="text-yellow-400 pb-4" data-id="element-68">:</span>
      <div className="flex flex-col items-center" data-id="element-69">
        <span className="bg-black/20 px-3 py-1 rounded-md" data-id="element-70">
          {formatTime(timeLeft.minutes)}
        </span>
        <span className="text-[10px] uppercase text-yellow-200 mt-1" data-id="element-71">Min</span>
      </div>
      <span className="text-yellow-400 pb-4" data-id="element-72">:</span>
      <div className="flex flex-col items-center" data-id="element-73">
        <span className="bg-black/20 px-3 py-1 rounded-md" data-id="element-74">
          {formatTime(timeLeft.seconds)}
        </span>
        <span className="text-[10px] uppercase text-yellow-200 mt-1" data-id="element-75">Seg</span>
      </div>
    </div>;
}